import React from 'react';
import './navbar.css';
import ComponentHelper from '../../supers/ComponentHelper';
import { NavLink } from 'react-router-dom';
import { ReactHintFactory } from 'react-hint';
import AuthService from '../../services/AuthService';
import RoutingService from '../../services/RoutingService';
const auth = new AuthService();
const ReactHint = ReactHintFactory(React);
const RS = new RoutingService();

class Navbar extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			openMenu: null,
			expandedMenu: false
		};

		this.autoBindAll(this);
	}

	onUserClick() {
		this.observe(() => {
			this.data.openMenu = 'user-menu';
		});
	}

	onMenuClickFilter() {
		this.observe(() => {
			this.data.openMenu = null;
		});
	}

	logout() {
		auth.logout();
	}

	onTenantManagement() {
		RS.setCurrentApplication(null);
		if (!RS.getCurrentTenant()) {
			RS.setCurrentEnvironment(null);
		}
	}

	entityClick() {
		setTimeout(() => {
			RS.goToRoute('/entities/models');
		}, 100);
	}

	buildOpenMenu() {
		let menu = null;

		switch (this.data.openMenu) {
			case 'user-menu': {
				menu = (
					<div className="nav-menu user-menu vbox animated fadeIn">
						<NavLink to="/user-profile" className="menu-item" title="User Profile">
							User Profile
						</NavLink>
						<div className="menu-item" onClick={this.logout}>
							Logout
						</div>
					</div>
				);
				break;
			}
			case 'manage-menu': {
				let { navItems } = this.props;
				menu = (
					<div className="nav-menu manage-menu vbox animated fadeIn">
						{navItems.indexOf('manage-users') >= 0 && (
							<NavLink to="/manage-users/users" className="menu-item" title="Manage Users">
								Manage Users
							</NavLink>
						)}
						{navItems.indexOf('manage-sandboxes') >= 0 && (
							<NavLink
								to={`/tenant-management/${RS.getCurrentTenant()}/environments`}
								className="menu-item"
								title="Manage Environments"
								onClick={this.onTenantManagement}
							>
								Manage Environments
							</NavLink>
						)}
						{navItems.indexOf('migrations') >= 0 && (
							<NavLink to={`/${RS.getCurrentTenant()}/migrations`} className="menu-item" title="Migrations">
								Migrations
							</NavLink>
						)}
					</div>
				);
				break;
			}
			default: {
				break;
			}
		}

		if (menu) {
			return (
				<div className="menu-click-filter" onClick={this.onMenuClickFilter}>
					{menu}
				</div>
			);
		}
	}

	getNavConfig(tenant) {
		return {
			tenants: {
				route: '/tenants',
				key: 'tenants-key',
				hintText: 'Tenants',
				icon: 'mdi-server'
			},
			'tenant-management': {
				route: `/tenant-management/${tenant}`,
				key: 'tenants-management-key',
				hintText: 'Tenant Management',
				icon: 'mdi-server-security'
			},
			'app-builder': {
				route: '/application-builder',
				key: 'application-builder-key',
				hintText: 'Application Builder',
				icon: 'mdi-cube-outline'
			},
			dashboard: {
				route: `/dashboard`,
				key: 'app-dashboard-key',
				hintText: 'Dashboard',
				icon: 'mdi-chart-areaspline'
			},
			composer: {
				route: `/app-composer`,
				key: 'app-theme-key',
				hintText: 'App Composer',
				icon: 'mdi-developer-board'
			},
			modules: {
				route: `/modules`,
				key: 'app-modules-key',
				hintText: 'Modules',
				icon: 'mdi-widgets'
			},
			connections: {
				route: `/connections`,
				key: 'app-connections-key',
				hintText: 'Connections',
				icon: 'mdi-lan-connect'
			},
			endpoints: {
				route: `/endpoints`,
				key: 'app-endpoints-key',
				hintText: 'Endpoints',
				icon: 'mdi-source-branch'
			},
			entities: {
				route: `/entities`,
				key: 'app-entities-key',
				hintText: 'Entities',
				icon: 'mdi-shape-plus'
			}
		};
	}

	getNavItems() {
		let items = [];
		let { tenant, navItems } = this.props;
		let navConfig = this.getNavConfig(tenant);
		for (let i = 0; i < navItems.length; i++) {
			let item = navItems[i];
			let config = navConfig[item];
			let clickHandler = item === 'tenant' ? this.onTenantManagement : item === 'entities' ? this.entityClick : undefined;
			if (config) {
				items.push(
					<NavLink
						to={config.route}
						className={`nav-btn hbox ${this.data.expandedMenu ? 'hleft' : 'hcenter'} vcenter animated slideInLeft`}
						activeClassName="active"
						key={config.key}
						data-rh={config.hintText}
						data-rh-at="right"
						onClick={clickHandler}
					>
						<i className={`mdi ${config.icon}`} />
						<div className="nav-item-details vbox vcenter animated fadeIn ellipse">{config.hintText}</div>
					</NavLink>
				);
			}
		}
		return items;
	}

	onManageClick() {
		this.observe(() => {
			this.data.openMenu = 'manage-menu';
		});
	}

	getMenus() {
		let { navItems } = this.props;
		let menus = [];
		if (navItems.indexOf('manage') >= 0) {
			menus.push(<i className="mdi mdi-settings nav-menu-item manage" key={'manage-icon'} onClick={this.onManageClick} />);
		}
		menus.push(<i className="mdi mdi-account nav-menu-item user" key={'user-icon'} onClick={this.onUserClick} />);
		return menus;
	}

	expandMenu() {
		this.setData('expandedMenu', !this.data.expandedMenu);
	}

	render() {
		let { expandedMenu } = this.data;
		return (
			<div className={`app-navbar vbox hcenter ${expandedMenu ? 'expanded' : ''}`}>
				<NavLink to="/tenants" className="nav-logo" title="Mad Cloud v2">
					<i className="mdi mdi-cloud-outline" />
					<div className="letter">m</div>
				</NavLink>
				<button className="btn nav-btn vbox vcenter hcenter" onClick={this.expandMenu}>
					<i className={`mdi ${expandedMenu ? 'mdi-close' : 'mdi-menu'}`} />
				</button>
				{this.getNavItems()}
				<div className="grow-1" />
				{this.getMenus()}
				{this.buildOpenMenu()}
				<ReactHint events hover />
			</div>
		);
	}
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/navbar/Navbar.js